import { useEffect, useState } from 'react';
import { DEBOUNCE_DELAY } from '../../constants';

/**
 *
 * @template T
 * @param {T} value
 * @param {number} delay
 * @returns {T}
 */
export default function useDebounce(value, delay = DEBOUNCE_DELAY) {
  const [debouncedValue, setDebouncedValue] = useState(value);

  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedValue(value);
    }, delay);

    return () => {
      clearTimeout(timer);
    };
  }, [value, delay]);

  return debouncedValue;
}
